export default {
  nav: {
    home: 'Home',
    articles: 'Articles',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    tools: 'Tools',
    about: 'About',
    sponsor: 'Membership',
    copyright: 'Copyright'
  },
  header: {
    searchPlaceholder: 'Search articles...',
    searchMobilePlaceholder: 'Search articles & tools...',
    search: 'Search',
    navLabel: 'Navigation',
    drawerHint: 'Browse · tap to navigate',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: 'Navigate',
    about: 'About',
    copyright: 'Copyright',
    feedback: 'Feedback',
    followUs: 'Follow us',
    channelsHint: 'Hover or tap QR to enlarge',
    allRights: 'All rights reserved',
    contactEmail: 'Contact',
    qrAlt: '{label} QR code',
    qrEnlarge: 'Enlarge {label} QR',
    close: 'Close',
    wechatScan: 'Scan with WeChat',
    filingHint: 'ICP for this domain: {label}',
    filingHintEmpty: 'ICP filing'
  },
  home: {
    readMore: 'Read more',
    noCarousel: 'No featured slides yet',
    noCarouselHint: 'Enable “Show on homepage carousel” in the admin article editor',
    latest: 'Latest',
    featured: 'Featured',
    views: 'views',
    softwareTitle: 'Software picks',
    softwareSubtitle: 'Handy apps for work, study, and development',
    tutorialTitle: 'Tutorials',
    tutorialSubtitle: 'From basics to real-world projects',
    resourceTitle: 'Resources',
    resourceSubtitle: 'Learning paths, open source, and book lists',
    techTitle: 'Tech articles',
    techSubtitle: 'Frontend, engineering, and performance',
    all: 'All',
    viewMore: 'See more',
    techCatTitle: '{cat} tech articles',
    emptyCategory: 'No posts in this category',
    seoIndex: 'All articles'
  },
  articles: {
    count: '{n} articles',
    searchPrefix: 'Search: {q}',
    all: 'All',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    titleAll: 'All articles',
    titleTech: 'Tech articles',
    titleSoftware: 'Software picks',
    titleTutorial: 'Tutorials',
    titleResource: 'Resources',
    titleNews: 'News',
    subCategory: 'Subcategory',
    softwareCats: 'Software categories',
    tutorialCats: 'Tutorial categories',
    resourceCats: 'Resource categories',
    techCats: 'Tech categories',
    tags: 'Tags',
    empty: 'No matching articles',
    featured: 'Featured'
  },
  article: {
    home: 'Home',
    body: 'Article',
    back: 'Back',
    repostFrom: 'Reposted from: ',
    readMinutes: '~{n} min',
    readAbout: 'Length',
    views: 'views',
    copyLink: 'Copy link',
    loadingBody: 'Loading content…',
    thanks: 'Thanks for reading',
    moreType: 'More {type}',
    related: 'Related',
    loading: 'Loading article…',
    notFound: 'Article not found',
    backToList: 'Back to articles',
    translationFallback: 'No English translation yet — showing Chinese original',
    original: 'Original',
    repost: 'Repost',
    publishedAt: 'Published {date}',
    updatedAt: 'Updated {date}',
    publish: 'Published',
    update: 'Updated',
    copied: 'Link copied',
    copyFailed: 'Copy failed',
    uncategorized: 'Uncategorized',
    authorDefault: 'Author',
    recommend: 'Recommended',
    hotTags: 'Popular tags',
    thisArticle: 'This article',
    category: 'Category',
    authorBio: 'Writing about tech and sharing useful notes',
    updatedShort: '↑',
    list: 'Articles'
  },
  friendLinks: {
    title: 'Blogroll',
    subtitle: 'Sites we recommend'
  },
  share: {
    label: 'Share',
    copyTo: 'Copy link for {name}',
    preview: 'Card preview',
    collapse: 'Hide preview',
    copied: 'Copied',
    copyLink: 'Copy link',
    previewTip: 'This card style appears when the link is pasted in WeChat, QQ, and similar apps',
    wechat: 'WeChat',
    qq: 'QQ',
    weibo: 'Weibo'
  },
  lock: {
    login: 'Sign-in required',
    member: 'Members only',
    paid: 'Paid',
    public: 'Public',
    loginMsg: 'Sign in to read this section',
    memberMsg: 'Become a member to read this section',
    paidMsg: 'Unlock this section with {n} {name}',
    paidMsgPlain: 'Unlock this section with {name}',
    myPoints: 'My {name}: ',
    insufficient: '(need {n} more)',
    loginRead: 'Sign in to read',
    openMember: 'Become a member',
    unlock: 'Unlock · {n} {name}',
    getPoints: 'Get {name}',
    loginFirst: 'Sign in first'
  },
  tools: {
    badge: 'Online toolkit',
    heroTitle: 'Practical tools, ready to use',
    heroDesc: 'PDF, images, barcodes, webmaster, life, networking, and config conversion — processed locally in your browser, fast and private.',
    countTools: 'tools',
    countCats: 'categories',
    localPct: 'local',
    searchPlaceholder: 'Search tools, e.g. PDF merge, QR code…',
    frequent: 'Frequent tools',
    frequentHintLogin: 'Synced to your account by usage; pin to keep on top',
    frequentHintGuest: 'Stored on this device; sign in to sync across devices',
    clear: 'Clear',
    clearConfirm: 'Clear frequent tools history?',
    cleared: 'Cleared',
    pin: 'Pin',
    unpin: 'Unpin',
    removeFrequent: 'Remove',
    frequentEmpty: 'Tools you use will appear here for quick access',
    all: 'All',
    toolsInCat: '{n} tools',
    empty: 'No matching tools',
    notFound: 'Tool not found',
    backHub: 'Back to toolkit',
    allTools: 'All tools',
    loginRequired: 'Sign in to use',
    loginTip: 'This tool requires an account. After signing in, files are processed locally in your browser.',
    loginNow: 'Sign in',
    tip: 'Notice',
    onlineTool: 'Online tool',
    ui: {
      drop: 'Click or drop files here',
      localHint: 'Processed locally — files are not uploaded',
      localHintMax: 'Processed locally; max {n}MB per image',
      fileTooLarge: 'File must be under {n}MB',
      process: 'Process',
      convert: 'Convert',
      copy: 'Copy',
      copied: 'Copied',
      copyManual: 'Please copy manually',
      paste: 'Paste',
      pasted: 'Pasted',
      clipboardFail: 'Could not read the clipboard',
      copyFail: 'Copy failed',
      input: 'Input',
      output: 'Output',
      encode: 'Encode',
      decode: 'Decode',
      escape: 'Escape',
      unescape: 'Unescape',
      format: 'Beautify',
      minify: 'Minify',
      lookup: 'Look up',
      yes: 'Yes',
      no: 'No',
      swapIo: 'Swap',
      result: 'Result…',
      optional: 'Optional',
      required: 'Required',
      done: 'Done',
      fail: 'Processing failed',
      generate: 'Generate',
      genOk: 'Generated',
      genFail: 'Generation failed',
      recognize: 'Decode',
      recOk: 'Decoded',
      download: 'Download',
      downloadImage: 'Download image',
      preview: 'Preview',
      empty: 'Leave empty'
    },
    pdf: {
      config: 'Options',
      dropPdf: 'Upload a PDF',
      dropPdfs: 'Upload multiple PDFs',
      dropImages: 'Upload one or more images',
      dropFirst: 'Upload the first PDF',
      dropSecondAlt: 'Upload the second PDF (interleave)',
      dropInsert: 'Upload the PDF to insert',
      dropLogo: 'Upload watermark / logo image',
      dropSign: 'Upload signature image (optional)',
      splitRange: 'Split ranges (e.g. 1-3;5;8-10)',
      splitPh: 'Empty = entire document as one file',
      deletePages: 'Pages to delete (e.g. 1-3,5,8-10)',
      exportFormat: 'Export format',
      page: 'Page',
      signText: 'Signature text',
      rotateAll: 'Rotate entire document',
      rotateHint: 'Or set rotation per page in the thumbnails below',
      pageN: 'Page {n}',
      angle: 'Angle',
      reorderHint: 'Drag to reorder (or use the arrows)',
      origPage: '#{i} · original page {n}',
      insertAfter: 'Insert after page (0 = beginning)',
      marginTop: 'Top margin (pt)',
      marginBottom: 'Bottom margin (pt)',
      marginLeft: 'Left margin (pt)',
      marginRight: 'Right margin (pt)',
      headerH: 'Header height (pt)',
      footerH: 'Footer height (pt)',
      paper: 'Paper size',
      nup: 'N-up',
      wmText: 'Watermark text',
      wmPh: 'Multiple lines supported',
      fontSize: 'Font size',
      opacity: 'Opacity',
      rotate: 'Angle',
      color: 'Color',
      mode: 'Mode',
      tile: 'Tile',
      center: 'Center',
      qrContent: 'QR content',
      qrPh: 'URL or text',
      scale: 'Scale',
      position: 'Position',
      posCenter: 'Center',
      posBR: 'Bottom right',
      posTR: 'Top right',
      posBL: 'Bottom left',
      posBC: 'Bottom center',
      posBR2: 'Bottom right',
      posTC: 'Top center',
      pageStart: 'Start number',
      template: 'Template',
      header: 'Header',
      footer: 'Footer',
      metaTitle: 'Title',
      metaAuthor: 'Author',
      metaSubject: 'Subject',
      metaKeywords: 'Keywords',
      metaCreator: 'Creator',
      metaProducer: 'Producer',
      gray: 'Grayscale',
      bw: 'Black & white',
      format: 'Format',
      extract: 'Extracted text',
      links: 'Links ({n})',
      loadMeta: 'Read current metadata',
      preview40: 'Previewing first 40 of {n} pages; processing still applies to all',
      metaLoaded: 'Metadata loaded ({n} pages)',
      readFail: 'Failed to read',
      pdfReady: 'PDF generated — download started',
      mergeOk: 'Merged',
      altMergeOk: 'Interleaved merge complete',
      exportedImgs: 'Exported {n} images',
      splitOk: 'Split into {n} files',
      compressOk: 'Compressed (basic in-browser)',
      optimizeOk: 'Optimized',
      unlockOk: 'Tried to lift restrictions and resaved',
      deletedPages: 'Deleted {n} pages',
      blankOk: 'Removed blank pages: {pages}',
      rotateOk: 'Rotated',
      reverseOk: 'Reversed',
      reorderOk: 'Reordered',
      reorderPartial: 'Reordered first {n} pages; remaining pages keep original order',
      waitThumbs: 'Wait for thumbnails before reordering',
      needPages: 'Specify pages to delete',
      noImages: 'No embedded images found',
      noLinks: 'No hyperlinks found',
      unknown: 'Unknown tool',
      insertOk: 'Inserted',
      cropOk: 'Cropped',
      hfOk: 'Header/footer area cropped by margins',
      sizeOk: 'Page size unified',
      nupOk: 'N-up layout applied',
      wmTextOk: 'Text watermark added',
      wmLogoOk: 'Logo watermark added',
      wmQrOk: 'QR watermark added',
      pageNumOk: 'Page numbers added',
      hfAddOk: 'Header and footer added',
      textOk: 'Text extracted and downloaded',
      extractImgs: 'Extracted {n} images',
      extractLinks: 'Extracted {n} links',
      metaSaved: 'Metadata saved',
      metaCleared: 'Metadata cleared',
      grayOk: 'Grayscale / B&W conversion done',
      longOk: 'Long image exported',
      signOk: 'Signed PDF exported',
      actions: {
        'pdf-to-images': 'Export images',
        'images-to-pdf': 'Create PDF',
        'pdf-split': 'Split PDF',
        'pdf-merge': 'Merge PDFs',
        'pdf-merge-alt': 'Interleave',
        'pdf-compress': 'Compress PDF',
        'pdf-optimize': 'Optimize & download',
        'pdf-delete-pages': 'Delete & export',
        'pdf-blank-pages': 'Remove blank pages',
        'pdf-rotate': 'Rotate & download',
        'pdf-reverse': 'Reverse & download',
        'pdf-reorder': 'Export new order',
        'pdf-insert': 'Insert & download',
        'pdf-crop': 'Crop & download',
        'pdf-page-size': 'Unify size & download',
        'pdf-nup': 'N-up & download',
        'pdf-watermark': 'Add watermark',
        'pdf-logo-watermark': 'Add logo watermark',
        'pdf-qr-watermark': 'Add QR watermark',
        'pdf-page-number': 'Add page numbers',
        'pdf-header-footer': 'Add header/footer',
        'pdf-remove-hf': 'Crop & download',
        'pdf-extract-text': 'Extract text',
        'pdf-extract-images': 'Extract images',
        'pdf-extract-links': 'Extract links',
        'pdf-metadata': 'Save metadata',
        'pdf-clear-metadata': 'Clear & download',
        'pdf-grayscale': 'Convert & download',
        'pdf-long-image': 'Export long image',
        'pdf-unlock': 'Unlock & download',
        'pdf-sign': 'Sign & export'
      }
    },
    image: {
      drop: 'Upload image',
      dropStitch: 'Upload images to stitch',
      dropResize: 'Upload image to resize',
      srcSize: 'Original size',
      resizeMode: 'Resize mode',
      custom: 'Custom size',
      percent: 'By percent',
      maxSide: 'Max side',
      lockRatio: 'Lock aspect',
      lockTip: 'Changing width or height updates the other side to match the original ratio',
      width: 'Target width',
      height: 'Target height',
      ratioBase: 'Anchor',
      byWidth: 'Keep width',
      byHeight: 'Keep height',
      scale: 'Scale',
      scaleTip: 'e.g. 10% turns 1024px into about 102px',
      maxW: 'Max width',
      maxH: 'Max height',
      maxTip: 'Shrinks to fit; will not upscale past the original',
      exportFmt: 'Export format',
      keepFmt: 'Original',
      quality: 'Quality',
      preview: 'Preview size',
      scaleAbout: '(about {n})',
      scaleWH: 'W {w}% / H {h}%',
      stitchH: 'Horizontal',
      stitchV: 'Vertical',
      block: 'Block size',
      maxBytes: 'Max size',
      qualityShort: 'Quality',
      wmPh: 'Watermark text',
      pos: 'Position',
      readFail: 'Could not read image size',
      resized: 'Resized to {w}×{h} — download started',
      gridOk: '9-grid images packed and downloaded',
      doneDl: 'Done — download started'
    },
    code: {
      inputPh: 'Enter text or URL',
      copybookPh: 'Enter Chinese characters',
      logo: 'Upload logo image',
      uploadCode: 'Upload image with a code',
      tabFile: 'Upload image',
      tabCam: 'Scan with camera',
      stopScan: 'Stop scanning',
      startCam: 'Start camera',
      camDefault: 'Please allow camera access in the browser.',
      hintQr: 'Align the QR code in the frame…',
      hintBar: 'Align the barcode in the frame…',
      hintDm: 'Align the Data Matrix in the frame…',
      hintHx: 'Align the Han Xin Code in the frame…',
      tipQr: 'Use the rear camera in good light; scanning stops automatically when decoded.',
      tipBar: 'Keep the barcode level, sharp, and free of glare.',
      tipDm: 'Data Matrix is a square matrix — keep the whole code in frame.',
      tipHx: 'Keep the full Han Xin Code in frame, sharp and glare-free; scanning stops when decoded.',
      hintDefault: 'Align the code in the frame…',
      camDenied: 'Cannot access the camera. Check browser permission or use HTTPS.',
      scanOk: 'Scanned',
      recFail: 'Could not decode. Try a sharper image.',
      camUnsupported: 'Camera is not supported in this environment',
      videoNotReady: 'Video is not ready'
    },
    convert: {
      tip: 'Paste config rules and convert. Review complex rules before using them.',
      swap: 'Swap input/output',
      copyOut: 'Copy result',
      phApache: 'Paste Apache .htaccess rules…',
      phNginx: 'Paste Nginx rewrite rules…'
    },
    ts: {
      tip: 'Convert Unix timestamps and datetimes (seconds or milliseconds). Edit either side to sync.',
      tsToDate: 'Timestamp → date',
      dateToTs: 'Date → timestamp',
      tsPh: 'e.g. 1704067200 or 1704067200000',
      nowSec: 'Now (sec)',
      nowMs: 'Now (ms)',
      local: 'Local time',
      utc: 'UTC',
      iso: 'ISO',
      weekday: 'Weekday',
      weekdayVal: '{d}',
      seconds: 'Seconds',
      millis: 'Milliseconds',
      pickDate: 'Pick date & time',
      datePh: 'Or paste: 2024-01-01 12:00:00',
      secTs: 'Unix seconds',
      msTs: 'Unix milliseconds',
      localShort: 'Local',
      parseTs: 'Could not parse timestamp',
      invalidDate: 'Invalid date',
      parseDate: 'Could not parse date',
      days: {
        日: 'Sunday',
        一: 'Monday',
        二: 'Tuesday',
        三: 'Wednesday',
        四: 'Thursday',
        五: 'Friday',
        六: 'Saturday'
      }
    },
    wm: {
      urlMode: 'Encode mode',
      urlAll: 'Encode all',
      phText: 'Enter text',
      phUrl: 'Enter a URL or text',
      phJson: 'Paste JSON',
      radix: 'Radix convert',
      radixFrom: 'From base',
      baseN: 'Base {n}',
      autoBase: 'Auto-detect',
      phRadix: 'e.g. 255, 0xff, 0b1010',
      htmlEsc: 'HTML escape',
      phHtml: 'Enter HTML / text',
      uuidTip: 'Generate RFC4122 UUID v4 (random).',
      genUuid: 'Generate UUID',
      genUuid5: 'Generate 5',
      phUnicode: 'Enter text or \\uXXXX',
      phHash: 'Text to hash',
      encodeFail: 'Encode failed',
      decodeFail: 'Decode failed',
      jsonErr: 'Invalid JSON: {msg}',
      convertFail: 'Convert failed',
      dec: 'Decimal',
      bin: 'Binary',
      oct: 'Octal',
      hex: 'Hex',
      b32: 'Base 32',
      b36: 'Base 36',
      metaTitle: 'Title',
      metaDesc: 'Description',
      metaKw: 'Keywords',
      metaUrl: 'URL',
      metaImg: 'Image',
      ogImg: 'OG image URL',
      copyCode: 'Copy code',
      allowAll: 'Allow all',
      disallow: 'Disallow paths',
      copyRobots: 'Copy robots.txt'
    },
    json: {
      tip: 'Format, minify, validate, sort keys, and escape JSON strings — all in the browser.',
      validate: 'Validate',
      sortKeys: 'Sort keys',
      escapeStr: 'Escape as string',
      unescape: 'Unescape',
      indentN: 'Indent {n}',
      phIn: 'Paste JSON…',
      done: 'Done',
      fmtOk: 'Formatted',
      minOk: 'Minified',
      sorted: 'Keys sorted',
      escaped: 'Escaped as a JSON string',
      escapeFail: 'Escape failed',
      unescaped: 'Unescaped',
      unescapeFail: 'Unescape failed'
    },
    fmt: {
      tip: 'Beautify or minify HTML / JS / CSS / XML / PHP. Also XML↔JSON and PHP obfuscation. Processed locally.',
      xmlJson: 'XML ↔ JSON',
      phpEnc: 'PHP encrypt',
      copyOut: 'Copy result',
      inputLang: 'Input · {lang}',
      phLang: 'Paste {lang} code…',
      xmlRoot: 'JSON→XML root name',
      inXmlJson: 'Input (XML or JSON)',
      phXmlJson: 'Paste XML or JSON…',
      swap: 'Swap',
      encMode: 'Method',
      encrypt: 'Encrypt / obfuscate',
      decrypt: 'Try decrypt',
      phpWarn: 'This is obfuscation, not strong encryption. It only hides source from casual reading.',
      phpSrc: 'PHP source',
      phPhp: 'Paste PHP, e.g. echo \'hello\';',
      fmtOk: 'Formatted',
      fmtFail: 'Format failed',
      minOk: 'Minified',
      minFail: 'Minify failed',
      xmlOk: 'XML → JSON done',
      jsonOk: 'JSON → XML done',
      convertFail: 'Convert failed',
      mixOk: 'Obfuscated',
      encFail: 'Encrypt failed',
      decOk: 'Decrypted',
      decFail: 'Decrypt failed'
    },
    byte: {
      tip: 'Enter a value and unit to convert across byte sizes. The decimal point stays as you typed it. Choose base 1024 (KiB/MiB) or 1000 (KB/MB).',
      ph: 'Number, e.g. 1024 or 1.5',
      base1024: 'Base 1024',
      base1000: 'Base 1000',
      unit: 'Unit',
      value: 'Value',
      action: 'Action',
      invalid: 'Enter a valid non-negative number'
    },
    ascii: {
      tip: 'Type English letters, digits, or common symbols and pick a font to make ASCII art. Use {nl} or Enter for a new line. Chinese is not supported; paste with a monospace font.',
      ph: 'e.g. wyqii cn or Hello\\nWorld (\\n = newline)',
      font: 'Font',
      layoutDefault: 'Default',
      layoutFull: 'Full',
      layoutFitted: 'Fitted',
      layoutSmush: 'Smush',
      empty: 'Type text above to preview ASCII art',
      genFail: 'Generation failed. Check the input or try another font.',
      gallery: 'All font previews',
      collapse: 'Collapse',
      use: 'Use',
      browse: 'Browse all fonts',
      switched: 'Switched to {name}',
      qClassic: 'Classic',
      qStandard: 'Standard',
      qBig: 'Big',
      qSlant: 'Slant',
      qBanner: 'Banner',
      qBlock: 'Block',
      qBubble: 'Bubble',
      qDigital: 'Digital',
      qStar: 'Star Wars'
    },
    whois: {
      tabWhois: 'Domain WHOIS',
      tabUa: 'User-Agent',
      tipWhois: 'Look up domain registration (WHOIS). Results depend on the server network and registry policy; some domains may be limited.',
      domain: 'Domain: {d}',
      server: 'WHOIS server: {s}',
      copyOut: 'Copy result',
      empty: 'No WHOIS content returned',
      fail: 'WHOIS lookup failed',
      tipUa: 'Parse the current or a custom User-Agent, with presets for common browsers, mini programs, and crawlers.',
      useLocal: 'Use this device UA',
      phUa: 'Paste User-Agent',
      parse: 'Parse',
      copyUa: 'Copy UA',
      browser: 'Browser',
      os: 'OS',
      device: 'Device',
      engine: 'Engine',
      mobile: 'Mobile',
      wechat: 'WeChat',
      bot: 'Bot',
      length: 'Length',
      presets: 'Presets',
      use: 'Use'
    },
    mac: {
      tip: 'Look up NIC vendor from MAC / OUI. About {n} common vendors locally; try online if missed.',
      ph: 'e.g. AA:BB:CC:DD:EE:FF or AABBCC',
      online: 'Online lookup',
      fail: 'Lookup failed',
      onlineFail: 'Online lookup failed',
      invalid: 'Enter at least 6 hex digits (OUI) or a full MAC',
      mac: 'Normalized MAC',
      oui: 'OUI',
      vendor: 'Vendor',
      unknown: 'Not found',
      localBit: 'Locally administered',
      multicast: 'Multicast',
      source: 'Source',
      srcLocal: 'Local',
      srcNone: 'Miss',
      srcOnline: 'Online',
      tipHit: 'Hit the local vendor list',
      tipMiss: 'Not in the local list — try the online lookup',
      tipOnline: 'Hit online',
      tipOnlineMiss: 'Not found online either'
    },
    regex: {
      tip: 'Write and test regex with presets and a metacharacter cheat sheet. Highlight matches and replace in the browser.',
      presets: 'Presets',
      phPattern: 'Regular expression',
      insert: 'Insert:',
      sample: 'Test text',
      phSample: 'Paste text to match',
      replace: 'Replace with (optional, $1 = group)',
      phReplace: 'Replacement',
      test: 'Test',
      copyRe: 'Copy regex',
      copyRepl: 'Copy replacement',
      matches: 'Matches',
      hit: '{n} hit(s)',
      none: 'No match',
      pos: 'Index',
      text: 'Match',
      groups: 'Groups',
      preview: 'Replace preview',
      tokens: 'Metacharacters',
      escapeSel: 'Escape selected / clipboard text',
      needCopy: 'Copy the text to escape first',
      escaped: 'Escaped as a literal regex',
      needPattern: 'Enter a regular expression',
      invalid: 'Invalid regex',
      replaceFail: 'Replace failed',
      runFail: 'Run failed',
      g: 'g global',
      gTip: 'Find all matches, not just the first',
      i: 'i ignore case',
      iTip: 'A and a match equally',
      m: 'm multiline',
      mTip: '^ $ match each line',
      s: 's dotall',
      sTip: '. also matches newlines',
      u: 'u Unicode',
      uTip: 'Treat as Unicode code points',
      y: 'y sticky',
      yTip: 'Match continuously from lastIndex',
      p: {
        email: { name: 'Email', desc: 'Common email format' },
        'mobile-cn': { name: 'CN mobile', desc: '11-digit mainland number' },
        url: { name: 'URL', desc: 'http/https links' },
        ipv4: { name: 'IPv4', desc: 'IPv4 address' },
        'id-card': { name: 'ID card', desc: '18-digit structure check' },
        'date-ymd': { name: 'Date YYYY-MM-DD', desc: 'Year-month-day' },
        'time-hms': { name: 'Time HH:mm:ss', desc: '24-hour clock' },
        chinese: { name: 'Chinese', desc: 'Consecutive Han characters' },
        number: { name: 'Number', desc: 'Integer or decimal' },
        'hex-color': { name: 'Hex color', desc: 'CSS color' },
        username: { name: 'Username', desc: 'Letter then 4–16 chars' },
        password: { name: 'Strong password', desc: 'Upper, lower, digit, symbol, ≥8' },
        'html-tag': { name: 'HTML tag', desc: 'Simple tag match' },
        'blank-line': { name: 'Blank line', desc: 'Empty or whitespace-only' },
        'trim-spaces': { name: 'Trim spaces', desc: 'Leading/trailing spaces' }
      }
    },
    pixel: {
      tip: 'Convert pixels ↔ cm / in / mm by DPI. You can also upload an image to read size and EXIF DPI (max 50MB).',
      ph: 'Enter a number',
      custom: 'Custom',
      unit: 'Unit',
      value: 'Value',
      action: 'Action',
      fromImage: 'Read from image',
      drop: 'Upload an image to read size / EXIF DPI',
      apply: 'Use width and convert',
      print: 'Print size ({dpi} DPI)',
      px: 'Pixels (px)',
      inch: 'Inches (in)',
      cm: 'Centimeters (cm)',
      mm: 'Millimeters (mm)',
      dpi72: '72 (screen)',
      dpi96: '96 (Windows)',
      dpi150: '150 (draft print)',
      dpi300: '300 (print)',
      readFail: 'Failed to read',
      invalid: 'Enter a valid number'
    },
    net: {
      ipTitle: 'IP geolocation',
      ipDesc: 'Look up country / region / city / ISP for an IP',
      ipPh: 'IPv4 address, e.g. 8.8.8.8',
      quick: 'Quick:',
      continent: 'Continent',
      country: 'Country / region',
      province: 'Province / state',
      city: 'City',
      isp: 'ISP',
      countryCode: 'Country code',
      latlng: 'Coordinates',
      raw: 'Raw data',
      ipEmpty: 'No geolocation data for this IP',
      needIp: 'Enter an IP address',
      domainTitle: 'Domain IP lookup',
      domainDesc: 'Resolve A/AAAA records and look up offline geolocation for each IPv4',
      domainPh: 'Domain, e.g. github.com or https://example.com',
      domainPrepend: 'Domain',
      resolve: 'Resolve',
      ipCount: '{n} IP(s)',
      engineOff: 'Offline IP database not ready — showing DNS results only',
      noGeo: 'No geolocation data',
      dnsRaw: 'Raw DNS records ({n})',
      needDomain: 'Enter a domain',
      resolveFail: 'Resolve failed',
      speedTitle: 'Speed test',
      speedDesc: 'Measure latency, download, and upload to this site. Results depend on server bandwidth and path — not your ISP plan peak.',
      downSize: 'Download size',
      upSize: 'Upload size',
      startSpeed: 'Start test',
      stop: 'Stop',
      speedResult: 'Results',
      latency: 'Latency (RTT)',
      downSpeed: 'Download',
      upSpeed: 'Upload',
      downTime: 'Download time',
      upTime: 'Upload time',
      transfer: 'Transferred',
      hintStart: 'Click start to measure latency → download → upload.',
      hintRun: 'Testing — keep this page open…',
      hintDone: 'Done. Values are measured on this site path for reference only.',
      hintStop: 'Test stopped.',
      phasePing: 'Measuring latency…',
      phaseDown: 'Download test…',
      phaseUp: 'Upload test…',
      phaseRun: 'Testing…',
      speedOk: 'Speed test finished',
      speedFail: 'Speed test failed',
      downFail: 'Download test failed',
      qAliDns: 'AliDNS',
      qBaidu: 'Baidu',
      qSite: 'This site'
    },
    netops: {
      latencyTitle: 'Host latency',
      latencyDesc: 'TCP connect latency to a public domain/IP (not ICMP ping). Probes run from this site’s server; private/loopback targets are blocked.',
      latencyPh: 'e.g. 1.1.1.1 or www.example.com',
      startTest: 'Start test',
      quick: 'Quick',
      target: 'Target',
      resolvedIp: 'Resolved IP',
      port: 'Port',
      reachable: 'Reachable',
      ok: 'OK',
      fail: 'Failed',
      avg: 'Average',
      minMax: 'Min / max',
      okCount: 'Successes',
      noteTcp: 'TCP connect time, not ICMP ping',
      needTarget: 'Enter a domain or IP',
      probeFail: 'Probe failed',
      lanTitle: 'LAN IP check',
      lanDesc: 'Compare WebRTC candidates with this site’s egress to guess LAN addresses and your public IP (browser support varies).',
      refresh: 'Refresh',
      localIp: 'Likely LAN IP',
      publicIp: 'Public IP',
      publicLoc: 'Public location',
      status: 'Status',
      lanNote: 'Some browsers or corporate networks hide host candidates. For full LAN scans, use the mini program.',
      detected: 'Detected',
      undetected: 'Not detected',
      lanEmpty: 'No address found — try another browser or the mini program',
      lanFail: 'Detection failed',
      camTitle: 'Camera check',
      camDesc: 'Browsers cannot scan LAN ports due to same-origin limits. Use the WeChat mini program (NetOps → camera check) on the same Wi‑Fi to probe common camera web ports.',
      cam1: 'The mini program can request LAN addresses within its permissions',
      cam2: 'This web page is guidance only — cross-origin probes would fail',
      cam3: 'You can also use the LAN speed test to check device connectivity',
      privA: 'Class A private (10.0.0.0/8)',
      privB: 'Class B private (172.16.0.0/12)',
      privC: 'Class C private (192.168.0.0/16)',
      loopback: 'Loopback',
      other: 'Likely public or other',
      qBaidu: 'Baidu',
      qAliDns: 'AliDNS',
      qSite: 'This site'
    },
    beian: {
      eyebrow: 'Webmaster compliance · sign-in required',
      title: 'ICP filing lookup',
      desc: 'After sign-in, look up website / APP / mini program / quick app ICP filings. Members can create an open API for scripts and systems.',
      tabQuery: 'Online query',
      tabApi: 'Open API',
      member: 'Member',
      try: 'Try:',
      openOfficial: 'Open official site',
      officialTitle: 'Query network security filing on the MPS official site',
      keyword: 'Keyword:',
      copyKw: 'Copy keyword',
      total: '{n} result(s)',
      officialLink: 'Official verify',
      empty: 'No filing found',
      apiTitle: 'Open API docs',
      apiDesc: 'Members can create a personal token and call the filing API over HTTP for scripts, ops, and integrations.',
      memberOn: 'Member active',
      needMember: 'Membership required',
      apiOnlyMember: 'Open API is members-only',
      apiOnlyMemberDesc: 'Web queries need sign-in; creating/rotating API tokens requires membership.',
      goMember: 'Get membership',
      goMemberHint: 'Then you can create a token and view the full API docs here',
      token: 'API token',
      enabled: 'Enabled',
      notCreated: 'Not created',
      tokenHintOn: 'A token exists. The full secret is shown only on create/rotate — rotate again if lost.',
      tokenHintOff: 'Create a token below to start calling the API.',
      rotate: 'Rotate token',
      create: 'Create API token',
      closeApi: 'Disable API',
      authTitle: '1. Authentication',
      authBody: 'Send the token in the request header (recommended):',
      authCompat: 'Also accepted:',
      queryApiTitle: '2. Query endpoint',
      copyUrl: 'Copy URL',
      param: 'Param',
      explain: 'Description',
      fieldsTitle: '3. Response fields',
      field: 'Field',
      curlTitle: '4. cURL example',
      jsTitle: '5. JavaScript example',
      notesTitle: '6. Notes',
      footerTitle: 'Notes',
      footer1: 'Web queries require a signed-in account; the open API needs a member token.',
      footer2: 'ICP data depends on the server upstream; network-security filing defaults to the official site.',
      footer3: 'Authoritative results are on the MIIT / MPS official platforms.',
      typeWeb: 'Website',
      typeApp: 'APP',
      typeMapp: 'Mini program',
      typeKapp: 'Quick app',
      typeWangan: 'Network security',
      phWeb: 'Domain / filing no. / owner, e.g. baidu.com',
      phApp: 'APP name / owner / filing no.',
      phMapp: 'Mini program name / owner / filing no.',
      phKapp: 'Quick app name / owner / filing no.',
      phWangan: 'Enter a domain to open the MPS official query',
      phDefault: 'Enter a keyword',
      prependDomain: 'Domain',
      prependKw: 'Keyword',
      hintWangan: 'Network-security filing opens the MPS official page by default; a paid upstream returns results directly when configured.',
      hintIcp: 'Search by domain, service name, owner, or filing number.',
      statusChecking: 'Checking service…',
      statusApiMember: 'Member open API',
      statusApiNeed: 'Open API needs membership',
      statusReady: 'ICP query ready',
      statusNotReady: 'ICP upstream not ready',
      statusWait: 'Please wait',
      statusApiOk: 'You can create a token and call the API',
      statusApiHint: 'Get membership first',
      statusFail: 'Could not load service status',
      loadApiFail: 'Failed to load open API',
      confirmRotate: 'The old token will stop working immediately. Continue?',
      confirmCreate: 'Create an open API token for filing lookups?',
      confirmTitle: 'Open API',
      confirmClose: 'The token will stop working immediately. Continue?',
      closeTitle: 'Disable open API',
      closed: 'Disabled',
      record: 'Filing record',
      fDomain: 'Domain',
      fSiteName: 'Site name',
      fOwner: 'Owner',
      fOwnerType: 'Owner type',
      fBeianCode: 'Filing no.',
      fPolice: 'Filing authority',
      fBeianDate: 'Filing date',
      fSiteType: 'Site type',
      fUnit: 'Sponsoring unit',
      fService: 'Service name',
      fMainLicence: 'Main licence',
      fServiceLicence: 'Service licence',
      fPassTime: 'Approved',
      fContentType: 'Pre-approval',
      fAddress: 'Address',
      nothingCopy: 'Nothing to copy',
      needKw: 'Enter a search keyword',
      wanganMsg: 'There is no long-term free stable public API for network-security filing. Please use the MPS official site.',
      queryFail: 'Query failed'
    },
    ico: {
      drop: 'Drop or click to upload an image and convert to ICO locally',
      clear: 'Clear',
      unnamed: 'Untitled image',
      quickTitle: 'Quick presets',
      quickSub: 'Select common size sets in one click',
      sizesTitle: 'Export sizes',
      selectAll: 'Select all',
      faviconOnly: 'Favicon only',
      clearSel: 'Clear',
      custom: 'Custom',
      addSize: 'Add {n}×{n}',
      extraAdded: 'Custom sizes:',
      fitTitle: 'Fit mode',
      bgTitle: 'Background',
      transparent: 'Transparent',
      solid: 'Solid',
      bgHint: 'Best for transparent PNG favicons',
      genDownload: 'Generate & download ICO',
      packCount: 'Will pack {n} size(s)',
      preview: 'Live preview',
      tiers: '{n} size(s)',
      previewEmpty: 'Upload an image to preview icons at the selected sizes',
      needSize: 'Select at least one export size',
      tips: 'Tips',
      tip1: 'Prefer a square, transparent PNG as the source',
      tip2: 'Website favicons often use 16 / 32 / 48',
      tip3: 'Generated in the browser — nothing is uploaded',
      tip4: 'Save as favicon.ico in your site root when done',
      customTip: 'Custom size',
      genOk: 'Generated {name} ({n} sizes, ~{kb} KB)',
      convertFail: 'Conversion failed',
      fitContain: 'Fit',
      fitContainHint: 'Scale to fit and center; pad empty edges (recommended)',
      fitCover: 'Cover',
      fitCoverHint: 'Scale to fill; crop overflow from the center',
      fitStretch: 'Stretch',
      fitStretchHint: 'Force-fill the square; may distort',
      qFavicon: 'Website favicon',
      qWindows: 'Windows icon',
      qApp: 'App icon',
      qAll: 'All sizes',
      tip16: 'Browser tab / classic favicon',
      tip24: 'Some toolbar icons',
      tip32: 'Hi-DPI favicon / taskbar',
      tip48: 'Windows Explorer',
      tip64: 'Desktop shortcut',
      tip128: 'Hi-DPI icon',
      tip256: 'Vista+ large icon'
    },
    exif: {
      lead: 'Upload a photo to read and edit full EXIF: serial number, lens / flash, contrast / saturation / sharpness, light source, white balance, EXIF version, detailed GPS, and more. Device / style / light / flash / lens presets are included; you can also save custom presets. Export as JPEG (local processing).',
      drop: 'Choose or drop a photo (JPEG / PNG / WebP, ≤50MB)',
      hasExif: 'Existing EXIF found',
      noExif: 'No EXIF / not JPEG — you can add fields manually',
      stampNow: 'Set time to now',
      justShot: 'Quick “just shot”',
      saveCustom: 'Save as custom',
      clearFields: 'Clear fields',
      export: 'Export',
      exportHint: 'Write all current fields into JPEG EXIF and download. Original JPEGs keep fidelity; other formats are converted to JPEG first.',
      jpegQuality: 'JPEG quality',
      fileName: 'File name',
      exportBtn: 'Export JPEG with EXIF',
      devicePresets: 'Device presets',
      styleBlock: 'Style · light · flash · lens',
      style: 'Style',
      light: 'Light source',
      flash: 'Flash',
      lens: 'Lens',
      myPresets: 'My custom presets',
      delete: 'Delete',
      gpsBlock: 'GPS city shortcuts (accuracy / status / area)',
      clearGps: 'Clear GPS',
      searchPh: 'Search fields (e.g. serial, contrast, GPS)',
      onlyFilled: 'Filled only',
      select: 'Select',
      readFail: 'Failed to read',
      sizeFail: 'Could not read image size',
      applied: 'Applied: {label}',
      appliedDevice: 'Applied {brand} {name}',
      gpsFilled: 'Filled {name} GPS details',
      timeSet: 'Capture time set to now',
      justShotOk: 'Filled “just shot” parameters',
      saveTitle: 'Save custom preset',
      savePrompt: 'Name this field set',
      savePh: 'e.g. street night / studio portrait',
      save: 'Save',
      cancel: 'Cancel',
      saved: 'Custom preset saved',
      exported: 'Exported',
      exportFail: 'Export failed'
    },
    ocr: {
      eyebrow: 'Alibaba DocMind · file OCR',
      title: 'Smart image & document recognition',
      desc: 'General text, ID cards, invoices, vehicles/logistics, and exam papers. Supports images and PDF. With admin approval you can use the open API for business systems.',
      available: 'left',
      pickScene: 'Pick a scene',
      quota: 'Quota {n}/month',
      notReadyEm: 'Service not ready — contact an admin',
      pausedEm: 'Temporarily unavailable',
      notReady: 'Service not ready',
      notReadyBody: 'Ask an admin to configure the Alibaba OCR AccessKey in the backend.',
      tabRec: 'Online OCR',
      tabApi: 'Open API',
      authorized: 'Authorized',
      replace: 'Click or drop to replace',
      replaceClick: 'Click to replace',
      dropTitle: 'Drop an image or PDF here',
      dropHint: 'JPG / PNG / BMP / WebP / GIF / TIFF / PDF / OFD · ~10MB max',
      clear: 'Clear',
      typeLabel: 'Recognition type',
      typePh: 'Select Type',
      pageLabel: 'PDF / OFD page (optional)',
      pageTip: 'For multi-page files; leave empty to use the first page.',
      keysLabel: 'Extract fields (optional, comma-separated)',
      keysPh: 'e.g. name, address, invoice date; leave empty for auto',
      outputTable: 'Output table structure',
      result: 'Result',
      text: 'Text',
      emptyText: '(No plain text — switch to JSON)',
      resultEmpty: 'Pick a scene and upload a file to start',
      apiTitle: 'Open API docs',
      apiDesc: 'After admin approval you can create a personal token and call OCR over HTTP for apps and scripts.',
      apiOk: 'Authorized',
      needAdmin: 'Needs admin approval',
      apiNeedTitle: 'Open API needs admin approval',
      apiNeedDesc: 'Ask an admin to enable OCR API under Users → Tool config and set a monthly quota. Users cannot enable it themselves.',
      notOpened: 'Not enabled',
      notOpenedHint: 'Web OCR still works; the open API needs separate approval.',
      token: 'API token',
      enabled: 'Enabled',
      notCreated: 'Not created',
      used: 'Used {used} / {limit}',
      remaining: '{n} left',
      tokenHintOn: 'A token exists. The full secret is shown only on create/rotate — rotate again if lost.',
      tokenHintOff: 'Create a token below to start calling the API.',
      rotate: 'Rotate token',
      create: 'Create API token',
      closeToken: 'Revoke token',
      authTitle: '1. Authentication',
      authBody: 'Send the token in the request header (recommended):',
      authCompat: 'Also accepted:',
      queryTitle: '2. Recognize endpoint',
      copyUrl: 'Copy URL',
      param: 'Param',
      explain: 'Description',
      fieldsTitle: '3. Response fields',
      field: 'Field',
      scenesTitle: '4. Scene IDs (sceneId)',
      curlTitle: '5. cURL example',
      jsTitle: '6. JavaScript example',
      notesTitle: '7. Notes',
      btnNotReady: 'Service not ready',
      btnPaused: 'Unavailable',
      btnNeedFile: 'Upload a file first',
      btnRun: 'Start OCR',
      loadFail: 'Failed to load OCR status',
      tooLarge: 'File too large — keep under ~10MB',
      recOk: 'Recognized',
      unavailable: 'Temporarily unavailable',
      recFail: 'Recognition failed',
      loadApiFail: 'Failed to load open API',
      confirmRotate: 'The old token will stop working immediately. Continue?',
      confirmCreate: 'Create an OCR open API token?',
      confirmTitle: 'Open API',
      tokenCreated: 'Token created — copy and save it now',
      confirmClose: 'The token will stop working immediately. Continue?',
      closeTitle: 'Revoke open API',
      closed: 'Token revoked'
    },
    battery: {
      tip: 'Convert battery capacity, series/parallel packs, runtime, and C-rate — useful for storage and consumer cells.',
      tabCap: 'Capacity',
      tabPack: 'Series / parallel',
      tabRuntime: 'Runtime',
      tabCrate: 'C-rate',
      presets: 'Common cells:',
      voltage: 'Voltage V',
      mah: 'Capacity mAh',
      orWh: 'or energy Wh',
      cellV: 'Cell voltage V',
      cellMah: 'Cell capacity mAh',
      series: 'Series S',
      parallel: 'Parallel P',
      loadMa: 'Load current mA',
      efficiency: 'Efficiency %',
      cRate: 'C-rate',
      orCurrentA: 'or current A',
      calc: 'Calculate',
      fail: 'Calculation failed',
      errVoltage: 'Enter a valid nominal voltage (V)',
      errMahOrWh: 'Enter either mAh or Wh',
      errCell: 'Enter a valid cell voltage and capacity',
      errRuntime: 'Enter capacity and load current',
      errMah: 'Enter battery capacity (mAh)',
      errCrate: 'Enter a C-rate or discharge current',
      r: {
        voltage: 'Voltage V',
        mAh: 'Capacity mAh',
        Ah: 'Capacity Ah',
        Wh: 'Energy Wh',
        combo: 'Config',
        cells: 'Cells',
        packV: 'Pack voltage V',
        packMah: 'Pack mAh',
        packAh: 'Pack Ah',
        packWh: 'Pack Wh',
        hours: 'Runtime hours',
        minutes: 'Runtime minutes',
        days: '≈ days',
        efficiency: 'Efficiency %',
        cRate: 'C-rate',
        currentA: 'Current A',
        currentMa: 'Current mA',
        ah: 'Capacity Ah'
      }
    },
    recording: {
      tabSize: 'Recording size',
      tabTime: 'Recording time',
      tabBw: 'Bandwidth',
      tipSize: 'Estimate continuous-recording disk size from codec, resolution (or custom bitrate), camera count, and days. Bitrates are industry references and vary with scene complexity.',
      tipTime: 'Given total disk capacity, estimate how long continuous recording lasts at the current quality and camera count.',
      tipBw: 'Estimate network bandwidth for recording/preview from camera count and per-stream bitrate, with ~20% headroom.',
      conditions: 'Inputs',
      byResolution: 'Resolution',
      byBitrate: 'Bitrate',
      codec: 'Codec',
      resolution: 'Resolution',
      fps: 'Frame rate',
      bitrate: 'Bitrate',
      recBitrate: 'Suggested bitrate',
      cameras: 'Cameras',
      camerasPh: 'e.g. 16',
      duration: 'Duration',
      durationPh: 'e.g. 30',
      capacity: 'Disk capacity',
      capacityPh: 'e.g. 8',
      reset: 'Reset',
      calc: 'Calculate',
      result: 'Result',
      sizeSub: 'Approx. capacity for continuous recording ({cameras} cams × {bitrate} Kbps × {days} days)',
      exact: 'Exact',
      suggestDisk: 'Suggested disk',
      sizeNote: 'Reserve ~15% headroom (formatting, indexes, bitrate spikes).',
      timeSub: 'Approx. continuous storage on {cap}',
      days: 'Days',
      hours: 'Hours',
      months: '≈ months',
      dayUnit: 'days',
      hourUnit: 'hours',
      monthUnit: 'months',
      bwSub: '{cameras} streams total (each {bitrate} Kbps)',
      totalBw: 'Total bandwidth',
      suggestBw: 'Suggested capacity',
      bwNote: 'Reserve ~20% link bandwidth; also consider switch backplane and NVR ports.',
      needBitrate: 'Enter a valid bitrate',
      fail: 'Calculation failed',
      errBw: 'Enter a valid camera count and bitrate',
      errSize: 'Enter a valid camera count, bitrate, and duration',
      errTime: 'Enter a valid camera count, bitrate, and disk capacity',
      uDay: 'Days',
      uHour: 'Hours',
      uMonth: 'Months (30d)',
      aboutDays: '~{n} GB',
      aboutTb: '~{n} TB'
    },
    eng: {
      disclaimer: 'For reference only — verify against applicable codes for real projects.',
      calc: 'Calculate',
      calcSize: 'Size cable',
      fail: 'Calculation failed',
      result: 'Results',
      byCurrent: 'By current',
      byPower: 'By power',
      singlePhase: 'Single-phase',
      threePhase: 'Three-phase',
      extraTag: 'Large estimate',
      dia: '≈ diameter φ{n} mm',
      ampacity: 'Ampacity ≈ {n} A',
      drop: 'Drop ≈ {n} V ({p}%)',
      limitedBy: 'Limited by {what}',
      byDrop: 'voltage drop',
      byAmpacity: 'ampacity',
      cableTitle: 'Cable sizing (copper / aluminum / gold / CCA)',
      cableTipPower: 'Enter load power and run length to recommend cross-section from ampacity and voltage drop.',
      cableTipCurrent: 'Enter load current and run length to recommend cross-section from ampacity and voltage drop.',
      mat: { cu: 'Copper', al: 'Aluminum', au: 'Gold', cca: 'CCA' },
      tip: {
        'cable-size': 'Recommend copper, aluminum, gold, or CCA size from current or power and run length.',
        'electrician-calc': 'Electrician tools: power/current, voltage drop, motors, three-phase, R/L, and more.',
        'room-calc': 'Room area, shape area, AC sizing, and paint/flooring estimates.',
        'unit-calc': 'Length, area, temperature, and percent/discount conversions.',
        'science-calc': 'Cylinders, triangles, quadrilaterals, circles, and spheres.',
        'other-tools': 'Electric, cable, and room calculators — switch from the left menu.'
      },
      m: {
        'cable-size': { title: 'Cable sizing', desc: 'Current or power → Cu/Al/Au/CCA size' },
        electric: { title: 'V / I / P', desc: 'Basic electrical conversions' },
        bill: { title: 'Energy cost', desc: 'Power × time → kWh and cost' },
        cable: { title: 'Voltage drop', desc: 'Drop from known cable size' },
        motor: { title: 'Motor I / P', desc: 'Motor current and power' },
        'delta-wye': { title: 'Delta / wye', desc: 'Three-phase connection and power' },
        resistance: { title: 'Resistance', desc: 'Ohm’s law / LED current limit' },
        inductance: { title: 'Inductance', desc: 'Reactance and series/parallel' },
        circuit: { title: 'Circuits', desc: 'Power, RC, capacitive reactance' },
        component: { title: 'Components', desc: 'Cutoff / resonance / divider' },
        cylinder: { title: 'Cylinder force', desc: 'Pneumatic force and pressure' },
        room: { title: 'Room area', desc: 'L×W, volume, multiple rooms' },
        shape: { title: 'Shape area', desc: 'Rect / triangle / circle / trapezoid' },
        'area-unit': { title: 'Area units', desc: 'm² / mu / hectare / ping' },
        ac: { title: 'AC sizing', desc: 'Match room area to AC tonnage' },
        material: { title: 'Paint & flooring', desc: 'Material from floor area' },
        length: { title: 'Length units', desc: 'mm / m / ft conversions' },
        temp: { title: 'Temperature', desc: '°C / °F / K' },
        percent: { title: 'Percent / discount', desc: 'Share, discount, savings' },
        'math-rect': { title: 'Rectangle / square', desc: 'Perimeter, area, diagonal' },
        'math-isosceles': { title: 'Isosceles triangle', desc: 'Sides, height, area, angles' },
        'math-triangle': { title: 'Triangle', desc: 'SSS / SAS / base×height' },
        'math-quad': { title: 'Quadrilateral', desc: 'Parallelogram / trapezoid / general' },
        'math-cylinder': { title: 'Cylinder', desc: 'Base, lateral area, volume' },
        'math-circle': { title: 'Circle', desc: 'Circumference and area' },
        'math-sphere': { title: 'Sphere', desc: 'Surface area and volume' },
        'math-cube': { title: 'Cube', desc: 'Surface, volume, space diagonal' },
        'math-pythagoras': { title: 'Pythagoras', desc: 'Right-triangle sides' }
      },
      r: {
        drop: 'Drop (V)',
        percent: 'Drop (%)',
        endVoltage: 'End voltage (V)',
        resistanceOne: 'Single-wire R (Ω)',
        tip: 'Note',
        current: 'Current (A)',
        inputPowerKw: 'Input power (kW)',
        apparentKva: 'Apparent (kVA)',
        formula: 'Formula',
        powerKw: 'Output power (kW)',
        horsepower: '≈ horsepower (HP)',
        connection: 'Connection',
        lineVoltage: 'Line voltage UL (V)',
        phaseVoltage: 'Phase voltage UP (V)',
        lineCurrent: 'Line current IL (A)',
        phaseCurrent: 'Phase current IP (A)',
        activeKw: 'Active power (kW)',
        reactiveKvar: 'Reactive (kvar)',
        areaMm2: 'Piston area (mm²)',
        pushForceN: 'Extend force (N)',
        pushForceKg: 'Extend force (kgf)',
        pullForceN: 'Retract force (N)',
        pullForceKg: 'Retract force (kgf)',
        pressureBar: 'Pressure (bar)',
        pressureMpa: 'Pressure (MPa)',
        xl: 'XL (Ω)',
        inductanceMh: 'L (mH)',
        totalMh: 'Equivalent L (mH)',
        resistance: 'Resistance (Ω)',
        voltage: 'Voltage (V)',
        total: 'Equivalent R (Ω)',
        powerW: 'Power (W)',
        tauSec: 'Time constant τ (s)',
        tauMs: 'Time constant τ (ms)',
        settle5Tau: '≈ 5τ (s)',
        xc: 'Xc (Ω)',
        cutoffHz: 'Cutoff (Hz)',
        resonateHz: 'Resonance (Hz)',
        vout: 'Vout (V)',
        ratio: 'Divider ratio',
        coolingW: 'Cooling (W)',
        coolingKw: 'Cooling (kW)',
        coolingBtu: 'Cooling (BTU/h)',
        suggestHp: 'Suggested HP',
        areaM2: 'Area (m²)',
        m2: 'Square meters m²',
        mu: 'Mu',
        hectare: 'Hectare',
        ping: 'Ping',
        sqft: 'Square feet',
        cm2: 'Square centimeters',
        areaPing: '≈ ping',
        areaSqft: '≈ sq ft',
        perimeterM: 'Perimeter (m)',
        volumeM3: 'Volume (m³)',
        wallAreaM2: 'Wall area (m²)',
        heightM: 'Ceiling (m)',
        roomsDetail: 'Breakdown',
        area: 'Area',
        circumference: 'Circumference',
        mm: 'mm',
        cm: 'cm',
        m: 'm',
        km: 'km',
        inch: 'inch',
        ft: 'ft',
        celsius: '°C',
        fahrenheit: '°F',
        kelvin: 'K',
        result: 'Result',
        finalPrice: 'Sale price',
        saved: 'Saved',
        offPercent: 'Discount (%)',
        netAreaM2: 'Net area (m²)',
        withWasteM2: 'With waste (m²)',
        paintLiters: 'Paint ≈ (L)',
        pieces: 'Planks ≈ (pcs)',
        pieceAreaM2: 'Piece area (m²)',
        loadCurrentA: 'Load current (A)',
        designCurrentA: 'Design current (A)',
        lengthM: 'Run length (m)',
        voltageV: 'Voltage (V)',
        phases: 'Phases',
        safetyFactor: 'Safety factor',
        recommendCu: 'Copper size',
        recommendAl: 'Aluminum size',
        recommendAu: 'Gold size',
        recommendCca: 'CCA size',
        detailCu: 'Copper note',
        detailAl: 'Aluminum note',
        detailAu: 'Gold note',
        detailCca: 'CCA note',
        kwh: 'Energy (kWh)',
        cost: 'Est. cost (CNY)',
        dailyKwh: 'Daily energy (kWh)',
        inputMode: 'Input mode',
        loadPowerW: 'Load power (W)',
        loadPowerKw: 'Load power (kW)',
        powerUnit: 'Power unit',
        side: 'Side / edge',
        length: 'Length',
        width: 'Width',
        perimeter: 'Perimeter',
        diagonal: 'Diagonal',
        equalSide: 'Equal side',
        base: 'Base',
        height: 'Height',
        apexAngleDeg: 'Apex (°)',
        baseAngleDeg: 'Base angle (°)',
        sideC: 'Side c',
        semiPerimeter: 'Semi-perimeter',
        baseArea: 'Base area',
        lateralArea: 'Lateral area',
        surfaceArea: 'Surface area',
        volume: 'Volume',
        radius: 'Radius',
        diameter: 'Diameter',
        faceArea: 'Face area',
        spaceDiagonal: 'Space diagonal',
        hypotenuse: 'Hypotenuse',
        otherLeg: 'Other leg'
      }
    }
  },
  about: {
    browseArticles: 'Browse articles',
    contactMe: 'Contact',
    role: 'Frontend developer · technical writer',
    bio1: 'A frontend developer focused on web engineering and UX. This blog is where I share notes, ideas, software picks, and project experience.',
    bio2: 'I aim to explain complex topics clearly and share useful tools so every visit is worthwhile.',
    online: 'Creating online',
    focusEyebrow: 'FOCUS',
    focusTitle: 'What I work on',
    focusSub: 'Write to capture experience; share to connect with more developers',
    focusWrite: 'Technical writing',
    focusWriteDesc: 'Frontend practice, engineering, and performance — explained clearly.',
    focusTools: 'Tool recommendations',
    focusToolsDesc: 'Curated apps and utilities that speed up daily work and learning.',
    focusTutorial: 'Hands-on tutorials',
    focusTutorialDesc: 'Project-based guides from beginner to advanced.',
    contentEyebrow: 'CONTENT',
    contentTitle: 'What you will find',
    contentSub: 'Four pillars covering beginner to advanced learning paths',
    techDesc: 'Frontend, performance, and engineering practice',
    softwareDesc: 'Utilities, office, and developer productivity apps',
    tutorialDesc: 'Structured learning from basics to advanced',
    resourceDesc: 'Learning materials, open source, and books',
    statArticles: 'Articles',
    statTech: 'Tech',
    statSoftware: 'Software',
    statTutorialResource: 'Tutorials & resources',
    techGroupFront: 'Frameworks',
    techGroupLang: 'Languages & styles',
    techGroupEng: 'Engineering',
    techGroupOther: 'Other',
    tagEng: 'Engineering',
    tagUx: 'UX',
    articleCount: '{n} articles',
    stackTitle: 'Stack',
    stackSub: 'Tools and frameworks used in daily work and writing',
    ctaTitle: 'Let’s talk',
    ctaDesc: 'Email is welcome for technical questions, collaboration, or content ideas. Thanks for supporting the site.',
    sponsorSupport: 'Support the site'
  },
  sponsor: {
    badge: 'Membership',
    title: 'Support {name} and unlock more content',
    desc: 'Your support helps keep tutorials, software picks, and tech articles coming. Choose how to start or renew.',
    memberUntil: 'Membership active until',
    renewNote: 'Renewals extend from the current expiry date',
    plansRenew: 'Renewal plans',
    plansBuy: 'Membership plans',
    plansDirectTip: 'Pick a plan and pay — membership activates automatically after payment',
    plansExternalTip: 'Buy on the card platform, then return here to redeem a CDK',
    plansIntroTip: 'Plan overview — activate with a redeem code after purchase',
    originalPrice: 'Was ¥{price}',
    unitPrice: 'About {unit}',
    renew: 'Renew',
    sponsorNow: 'Sponsor now',
    goBuy: 'Buy now',
    onlineBuy: 'Buy membership online',
    empty: 'Membership purchase is not available yet. Please contact the admin.',
    faqTitle: 'FAQ',
    faq1q: 'What do I get as a member?',
    faq1a: 'Read all “members only” articles and sections site-wide, and view sponsorship orders in your profile.',
    faq2q: 'How is renewal calculated?',
    faq2a: 'If your membership is still active, the new plan extends from the current expiry. If it has expired, it starts from the activation date.',
    faq3q: 'How do I use a CDK code?',
    faq3a: 'Buy a plan on the card shop, sign in here, enter the code above, and redeem to activate the matching duration.',
    faq4q: 'How do I activate after purchase?',
    faq4a: 'After buying on the card shop, return here and enter the CDK code to activate membership.',
    cdkReturnHint: 'After purchase, return here and enter the code to activate',
    confirmRenew: 'renew',
    confirmSponsor: 'sponsor',
    confirmTitle: '{action} membership',
    confirmMsg: 'Confirm {action} “{name}”? (¥{price}, {duration})',
    confirmOk: 'Confirm {action}',
    cancel: 'Cancel'
  },
  profile: {
    member: 'Member',
    normalUser: 'Regular user',
    joinedAt: 'Joined {date}',
    memberUntil: 'Member until {date}',
    changeAvatar: 'Change avatar',
    admin: 'Admin',
    renew: 'Renew',
    openSponsor: 'Become a member',
    history: 'History',
    orders: 'Orders',
    unlocked: 'Unlocked',
    sideLabel: 'Account',
    navAria: 'Profile navigation',
    tabInfo: 'Profile',
    tabInfoShort: 'Profile',
    tabSecurity: 'Security',
    tabSecurityShort: 'Security',
    tabHistory: 'History',
    tabHistoryShort: 'History',
    tabPoints: 'Points',
    tabPointsShort: 'Points',
    tabMember: 'Membership',
    tabMemberShort: 'Member',
    tabOrders: 'Orders',
    tabOrdersShort: 'Orders',
    guestTitle: 'Sign in to manage your account',
    guestDesc: 'Sync history, check-ins, membership, and orders',
    loginNow: 'Sign in'
  },
  copyright: {
    backHome: 'Back to home',
    title: 'Copyright notice',
    desc: 'Welcome to “{name}”. Please read the terms below. By using this site you agree to this notice.',
    updated: 'Last updated: Mar 10, 2026',
    effective: 'Effective: Jan 1, 2026',
    toc: 'Contents',
    contactPrefix: 'Questions about this notice? Email',
    contactSuffix: 'and we will reply within a reasonable time.',
    enNotice: 'The English version is for reference only. If it conflicts with the Chinese text, the Chinese version prevails.'
  },
  redirect: {
    back: 'Go back',
    leaving: 'You are leaving this site',
    invalid: 'Invalid link',
    leavingDesc: 'You are about to open a third-party site. Please confirm the destination first.',
    invalidDesc: 'This link could not be parsed. Check that the address is correct.',
    targetSite: 'Destination',
    copy: 'Copy',
    copied: 'Copied',
    linkName: 'Link title',
    fromArticle: 'From article',
    safety: 'Safety tips',
    tip1: 'Third-party content, privacy, and security are the responsibility of that site.',
    tip2: 'Do not enter passwords or payment details on unfamiliar pages.',
    tip3: 'If a page looks suspicious, close it and return here.',
    cancel: 'Cancel',
    confirm: 'Continue',
    countdown: 'After you confirm, the link opens in a new tab; this page stays open',
    invalidReason: 'Possible causes: bad URL format, unsupported protocol, or missing redirect parameter.',
    backHome: 'Back to home',
    footerTip: '{name} shows this warning before external links to help keep browsing safer'
  },
  common: {
    langSwitched: 'Language updated',
    tip: 'Notice',
    backTop: 'Back to top',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    reply: 'Reply'
  },
  comments: {
    title: 'Comments',
    approvalTip: 'Comments are reviewed before public display. Your pending ones are marked “Pending”.',
    placeholder: 'Share your thoughts — images and links are supported…',
    submit: 'Post comment',
    loading: 'Loading comments…',
    empty: 'No comments yet — be the first',
    pending: 'Pending',
    hidden: 'Hidden',
    replyTo: 'Reply',
    editPh: 'Edit comment…',
    replyPh: 'Reply to @{name}…',
    submitReply: 'Post reply',
    loadFailed: 'Failed to load comments',
    pickImage: 'Please choose an image',
    imageInserted: 'Image inserted',
    uploadFailed: 'Image upload failed',
    needContent: 'Please enter a comment',
    needReply: 'Please enter a reply',
    posted: 'Comment posted',
    postFailed: 'Failed to post',
    replied: 'Reply posted',
    replyFailed: 'Failed to reply',
    emptyContent: 'Comment cannot be empty',
    updated: 'Comment updated',
    updateFailed: 'Update failed',
    deleteConfirm: 'Delete this comment?',
    deleted: 'Comment deleted',
    deleteFailed: 'Delete failed'
  },
  auth: {
    login: 'Sign in',
    logout: 'Sign out',
    loggedOut: 'Signed out',
    register: 'Sign up',
    createAccount: 'Create account',
    welcomeBack: 'Welcome back',
    joinUs: 'Join us',
    forgotTitle: 'Reset password',
    welcomeDesc: 'Sign in to continue reading',
    registerDesc: 'Create an account to unlock more',
    qrDesc: 'Scan with WeChat for a quick, secure sign-in',
    forgotDesc1: 'Verify your registered email to reset the password',
    forgotDesc2: 'Set a new password, then sign in again',
    featCollect: 'Save articles you like',
    featHistory: 'Sync reading history',
    featPersonal: 'A more personal reading experience',
    featEmail: 'Email verification keeps the account safer',
    featCode: 'Codes expire in 10 minutes',
    featReset: 'Sign in right after a reset',
    passwordLogin: 'Password',
    qrLogin: 'Mini-program QR',
    account: 'Account',
    accountPh: 'Username or email',
    password: 'Password',
    passwordPh: 'Enter password',
    forgot: 'Forgot password?',
    noAccount: 'No account yet?',
    registerNow: 'Create one',
    hasAccount: 'Already have an account?',
    loginNow: 'Sign in',
    backLogin: 'Back to sign in',
    username: 'Username',
    usernamePh: 'More than 5 characters',
    email: 'Email',
    emailCode: 'Email code',
    codePh: '6-digit code',
    getCode: 'Get code',
    resendIn: 'Resend in {n}s',
    resend: 'Resend',
    passwordRule: 'More than 8 characters',
    confirmPassword: 'Confirm password',
    confirmPh: 'Enter password again',
    forgotHint1: 'Enter your registered email to get a code',
    forgotHint2: 'Set a new password',
    registeredEmail: 'Registered email',
    registeredEmailPh: 'The email you used to register',
    sendCode: 'Send code',
    code: 'Code',
    newPassword: 'New password',
    newPasswordPh: 'At least 6 characters',
    qrAlt: 'Scan to sign in',
    qrLoading: 'Loading QR…',
    qrExpired: 'Expired — tap to refresh',
    qrRefresh: 'Refresh QR',
    qrPending: 'Scan with WeChat, open the mini program, then confirm',
    qrExpiredHint: 'QR expired. Please refresh',
    qrCancelled: 'Cancelled. Refresh to try again',
    qrError: 'QR failed to load',
    rememberPassword: 'Remembered it?',
    resetPassword: 'Reset password',
    confirmNewPassword: 'Confirm new password',
    confirmNewPh: 'Enter the new password again'
  },
  user: {
    menu: 'Account menu',
    member: 'Member',
    normal: 'Regular user',
    expireUntil: 'Active until {date}',
    openHint: 'Become a member to unlock more content',
    checkin: 'Check in',
    checkinDaily: 'Daily check-in',
    checkedIn: 'Done',
    checkedInToday: 'Checked in today',
    checkinReward: 'Earn +{n} {name}',
    profile: 'Profile',
    myPoints: 'Points',
    history: 'History',
    recent: 'Recently viewed',
    viewAll: 'See all',
    noHistory: 'No reading history yet',
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    streak: '{n}-day streak'
  }
}
